export default __webpack_public_path__ + "static/media/product-pc-2.e6a5d615.png";